import React, { useEffect, useState } from "react";
import { AUARequest } from '../AUA';
import { T } from "../traks";
import { Spinner } from "reactstrap";
import store from "../store";
import { mainGameId } from '../GameConfig'
import API from "../API";

export default function Callback() {
    const [me, setMe] = useState(() => store.getState().me);
    const [userJWT, setUserJWT] = useState(null);
    const [groupGameId, setGroupGameId] = useState(0);
    const [groupGameInviteKey, setGroupGameInviteKey] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const gameId = mainGameId;

    useEffect(() => {
        const unsubscribe = store.subscribe(() => {
          setMe(store.getState().me);
        });
        return unsubscribe;
      }, []);

    useEffect(() => {
        const url = new URLSearchParams(window.location.search)
        const groupId = url.get('groupGameId');
        const groupInviteKey = url.get('groupGameInviteKey');
        const token = url.get("token");

        if (token) {
          setUserJWT(token);
        }

        if (groupId) {
            setGroupGameId(parseInt(groupId));
        }

        if (groupInviteKey) {
            setGroupGameInviteKey(groupInviteKey);
        }
      }, [me]);

      useEffect(() => {    
        if (!userJWT) {
          setLoading(false);
          return;
        }
    
        setLoading(true);
    
        AUARequest.login_with_jwt(userJWT, groupGameId, groupGameInviteKey, err => {
          if (err) {
            setError("An error occurred while logging in with JWT: " + err);
            setLoading(false);
          } else {
            API.get("/a/berlingske/is_user_in_game", {}, (res, status) => {
              if (status !== 200) {
                setError("An error occurred while checking game status");
                setLoading(false);
                return;
              }
              if (res.IsInGame) {
                window.location.replace(`/game/${gameId}`);
              } else {
                window.location.replace(`/`);
              }
            });
          }
          return;
        });
      }, [userJWT]);

  return (
    <div className="callback-container">
      {loading && <Spinner className="p-2" />}
      <h1 className="p-2"><T>Loading...</T></h1>

      {error && <div className="callback-error">{error}</div>}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/p/Callback.js